import { DamageType } from "../damageType";
import type { Direction } from "../direction";
import { SmokeEffect } from "../effects/smokeEffect";
import type { ParticleEmitter } from "../interfaces";
import { ParticleType } from "../particleType";
import type { PhysicalThingWithHp } from "../physicalThingWithHp";
import { STD_BASE_HP } from "../physicalThingWithHp";
import { deserializeXY } from "../serialization";
import { SimpleProjectile } from "../simpleProjectile";
import type { XY } from "../xy";

export class DrillBullet extends SimpleProjectile implements ParticleEmitter {
	static key = "DrillBullet";

	getParticleType(): ParticleType {
		return ParticleType.DRILL_TRAIL;
	}

	private resist: number = 6;

	constructor(xy: XY, direction: Direction) {
		super(xy, direction);
	}

	protected damageTarget(target: PhysicalThingWithHp): number {
		return target.applyDamage(DamageType.EXPLOSION, STD_BASE_HP, this);
	}

	onHit(damageDealt: number): void {
		this.board!.addEffect(new SmokeEffect(this.xy));
		this.resist--;
		if (this.resist <= 0 || damageDealt <= 0) {
			this.board!.removeAtEndOfTurn(this);
		}
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), resist: this.resist };
	}

	static deserialize(data: any): DrillBullet {
		const bullet = new DrillBullet(deserializeXY(data.xy), data.direction as Direction);
		bullet.visualId = data.visualId;
		bullet.resist = data.resist;
		return bullet;
	}
}
